import React from "react";
import { useDispatch } from "react-redux";
import { InputFieldResponsive } from "../../component/Utils";
import { Input, Label, Button, Modal, ModalBody, Badge } from "reactstrap";
import { Icon, Loader, Button as ButtonS } from "semantic-ui-react";
import moment from "moment-timezone";
import { deleteDataAction } from "../../config/redux/action";
import { BASE_URL } from "../../constants";
import { useParams, useHistory } from "react-router-dom";
import { performance, talent, development } from "./LevelPegawai";
import { HeaderComp } from "../TambahPegawai/HeaderComp";
import { isBiro, axiosConfig } from "../../utils/helper";
import Axios from "axios";
import LoadingTop from "../../component/LoadingTop";

const ParsedDateInd = (date) => {
  return date
    ? moment.utc(date).locale("id").tz("Asia/Jakarta").format("DD MMMM YYYY")
    : "";
};

const ActionButton = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [modalDelete, setModalDelete] = React.useState(false);
  const [onDelete] = React.useState(false);
  const deletePegawai = () => {
    const o = {
      path: `pegawai/${props.pegawai?.id}`,
      title: "Pegawai",
    };
    dispatch(deleteDataAction(o)).then(() => {
      setModalDelete(false);
      window.history.back();
    });
  };

  const edit = () => history.push(`/pegawai/edit/${props.pegawai?.id}`);
  return (
    <div className="d-flex justify-content-end">
      <Button
        type="button"
        color="danger"
        className="mr-3"
        onClick={() => setModalDelete(true)}
      >
        Delete
      </Button>
      <ButtonS type="submit" color="blue" onClick={edit}>
        Edit
      </ButtonS>
      <Modal isOpen={modalDelete} toggle={() => setModalDelete(!modalDelete)}>
        <ModalBody className="text-center my-3">
          <Icon color="red" name="trash alternate outline" size="large" />
          <h3>Delete Pegawai</h3>
          <p>
            Apakah Anda yakin akan menghapus Pegawai{" "}
            <Badge color="success">
              <strong>{props.pegawai?.nama}</strong>
            </Badge>
            <br />
            Proses ini tidak dapat diurungkan.
          </p>
          <div>
            <Button
              className="mr-3"
              disabled={onDelete}
              onClick={() => setModalDelete(false)}
            >
              Cancel
            </Button>
            <Button
              primary
              disabled={onDelete}
              color="danger"
              onClick={() => deletePegawai()}
            >
              Delete
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};
export default () => {
  const { idPegawai } = useParams();
  const [data, setData] = React.useState();
  const init = (d) => {
    d.jenisKelamin = d.jenisKelamin
      ? d.jenisKelamin === 1
        ? "Laki Laki"
        : "Perempuan"
      : "";
    const bakat = talent.filter((p) => p.value === d.bakat)[0]?.text;
    const performa = performance.filter((p) => p.value === d.performa)[0]?.text;
    const pengembangan = development.filter(
      (p) => p.value === d.pengembangan
    )[0]?.text;
    const temp = {
      ...d,
      bakat,
      performa,
      pengembangan,
    };
    if (d.kelurahanId === null || d.kelurahanId.length === 0) {
      setData({ ...temp });
      return;
    }
    const url = `${BASE_URL}/kelurahan/parent/${d.kelurahanId}`;
    Axios.get(url, axiosConfig()).then((res) => {
      const a = res.data;
      setData({
        ...temp,
        provinsi: a?.provinsi?.name,
        kabupaten: a?.kabupaten?.name,
        kecamatan: a?.kecamatan?.name,
        kelurahan: a?.kelurahan?.name,
      });
    });
  };
  const tombolkembali = (e) => {
    e.preventDefault();
    window.history.back();
  };
  React.useEffect(() => {
    const path = `${BASE_URL}/pegawai/${idPegawai}`;
    Axios.get(path, axiosConfig()).then((response) => {
      const d = response.data;
      init(d);
    });
  }, []);
  if (data === undefined) {
    return (
      <div className="w-100 d-flex justify-content-center my-5">
        <Loader active>Loading</Loader>
      </div>
    );
  }
  return (
    <>
      <LoadingTop />
      <HeaderComp title="Detail Pegawai" />
      <div className="container mt-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card container py-3 border-0">
              <div className="w-md-100">
                {/* {!isBiro() && <ActionButton pegawai={data} />} */}
                <hr />
                <h4>Profil</h4>
                <InputFieldResponsive
                  label="NIK"
                  inputType={{ disabled: true, value: data.nik }}
                />
                <InputFieldResponsive
                  label="Nama Lengkap"
                  inputType={{ disabled: true, value: data.nama }}
                />
                <InputFieldResponsive
                  label="Jenis Kelamin"
                  inputType={{ disabled: true, value: data.jenisKelamin }}
                />
                <InputFieldResponsive
                  label="No. Telepon"
                  inputType={{ disabled: true, value: data.telepon || "" }}
                />
                <InputFieldResponsive
                  label="Email"
                  inputType={{ disabled: true, value: data.email || "" }}
                />
                <InputFieldResponsive
                  label="Tempat Lahir"
                  inputType={{
                    disabled: true,
                    value: data && data.tempatLahir,
                  }}
                />
                <div className="row mb-2">
                  <div className="col-md-4 d-flex align-items-center">
                    <Label>Tanggal Lahir</Label>
                  </div>
                  <div className="col-md-8">
                    <Input
                      type="text"
                      disabled
                      value={data && ParsedDateInd(data.tanggalLahir)}
                    />
                  </div>
                </div>
                <h4>Alamat</h4>
                <InputFieldResponsive
                  label="Alamat Lengkap"
                  inputType={{
                    disabled: true,
                    type: "textarea",
                    value: data.alamat || "",
                  }}
                />
                <InputFieldResponsive
                  label="Provinsi"
                  inputType={{
                    disabled: true,
                    value: data.provinsi,
                  }}
                />
                <InputFieldResponsive
                  label="Kabupaten"
                  inputType={{
                    disabled: true,
                    value: data.kabupaten,
                  }}
                />
                <InputFieldResponsive
                  label="Kecamatan"
                  inputType={{
                    disabled: true,
                    value: data.kecamatan,
                  }}
                />
                <InputFieldResponsive
                  label="Kelurahan"
                  inputType={{
                    disabled: true,
                    value: data.kelurahan,
                  }}
                />
                <h4>Pendidikan</h4>
                <InputFieldResponsive
                  label="SMP"
                  inputType={{ disabled: true, value: data.smp || "" }}
                />
                <InputFieldResponsive
                  label="SMA"
                  inputType={{ disabled: true, value: data.sma || "" }}
                />
                <InputFieldResponsive
                  label="S1"
                  inputType={{ disabled: true, value: data.s1 || "" }}
                />
                <InputFieldResponsive
                  label="S2"
                  inputType={{ disabled: true, value: data.s2 || "" }}
                />
                <InputFieldResponsive
                  label="S3"
                  inputType={{ disabled: true, value: data.s3 || "" }}
                />
                <h4>Pekerjaan</h4>
                <InputFieldResponsive
                  label="Tanggal Masuk"
                  inputType={{
                    disabled: true,
                    value: data && ParsedDateInd(data.mulaiKerja),
                  }}
                />
                <InputFieldResponsive
                  label="Posisi"
                  inputType={{ disabled: true, value: data.posisi || "" }}
                />
                <InputFieldResponsive
                  label="Tingkat"
                  inputType={{ disabled: true, value: data.tingkat || "" }}
                />
                <InputFieldResponsive
                  label="Divisi"
                  inputType={{ disabled: true, value: data.divisi || "" }}
                />
                <InputFieldResponsive
                  label="Departemen"
                  inputType={{ disabled: true, value: data.departemen || "" }}
                />
                <InputFieldResponsive
                  label="Performa"
                  inputType={{ disabled: true, value: data.performa }}
                />
                <InputFieldResponsive
                  label="Bakat"
                  inputType={{ disabled: true, value: data.bakat }}
                />
                <InputFieldResponsive
                  label="Pengembangan"
                  inputType={{
                    disabled: true,
                    value: data.pengembangan,
                  }}
                />

                <hr />
                {/* {!isBiro() && <ActionButton pegawai={data} />} */}
              </div>
              <div className="d-flex justify-content-end">
                <ButtonS type="button" color="blue" className="mr-3" onClick={(e) => tombolkembali(e)}>Back</ButtonS>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
